module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "赛区",
      "input-align": "right",
      "readonly": ""
    },
    model: {
      value: (_vm.formData.saiqu_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "saiqu_name", $$v)
      },
      expression: "formData.saiqu_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "单位",
      "input-align": "right",
      "readonly": ""
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '队伍名称不能为空'
      }],
      "label": "队伍名称",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入队伍名称"
    },
    model: {
      value: (_vm.formData.mingcheng),
      callback: function($$v) {
        _vm.$set(_vm.formData, "mingcheng", $$v)
      },
      expression: "formData.mingcheng"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.mingcheng),
      expression: "formData.mingcheng"
    }],
    staticClass: "operate-desc-left"
  }, [_vm._v("您的队伍全称是 " + _vm._s(_vm.formData.danwei) + " " + _vm._s(_vm.formData.mingcheng) + " " + _vm._s(_vm.formData.mingcheng_end))]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "队伍照片",
      "value": _vm.formData.heying.length + '/1'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.heying,
      "limit": 1,
      "name": 'heying'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("上传一张队伍照片")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "领队姓名",
      "rules": [{
        required: true,
        message: '领队姓名不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入领队姓名"
    },
    model: {
      value: (_vm.formData.ldname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ldname", $$v)
      },
      expression: "formData.ldname"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "证件类型"
    },
    on: {
      "click": function($event) {
        _vm.showNumTypePicker = true
      }
    },
    model: {
      value: (_vm.formData.numTypeName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "numTypeName", $$v)
      },
      expression: "formData.numTypeName"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showNumTypePicker),
      callback: function($$v) {
        _vm.showNumTypePicker = $$v
      },
      expression: "showNumTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.numTypeColumns,
      "show-toolbar": "",
      "default-index": _vm.formData.ldcardtype - 1
    },
    on: {
      "cancel": function($event) {
        _vm.showNumTypePicker = false
      },
      "confirm": _vm.onNumTypeConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "证件号码",
      "rules": [{
        required: true,
        message: '证件号码不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入证件号码"
    },
    model: {
      value: (_vm.formData.ldnum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ldnum", $$v)
      },
      expression: "formData.ldnum"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "领队性别",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.ldsex),
            callback: function($$v) {
              _vm.$set(_vm.formData, "ldsex", $$v)
            },
            expression: "formData.ldsex"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": 1
          }
        }, [_vm._v("男")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": 2
          }
        }, [_vm._v("女")])], 1)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "领队手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "联系人",
      "rules": [{
        required: true,
        message: '联系人不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入联系人姓名"
    },
    model: {
      value: (_vm.formData.lxname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lxname", $$v)
      },
      expression: "formData.lxname"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "联系人手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.lxphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lxphone", $$v)
      },
      expression: "formData.lxphone"
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("教练裁判信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "随队裁判",
      "placeholder": "请选择裁判"
    },
    on: {
      "click": function($event) {
        _vm.showCaipanPicker = true
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.caipan.length > 0),
      expression: "formData.caipan.length>0"
    }],
    staticClass: "memberResultWrap"
  }, _vm._l((_vm.formData.caipan), function(caipan, index) {
    return _c('div', {
      staticClass: "memberLi"
    }, [_vm._v("\n                    裁判员\n                    "), _c('van-tag', {
      key: index,
      attrs: {
        "round": "",
        "color": "#fff",
        "text-color": "#666",
        "size": "large",
        "closeable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.caipan.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(caipan.name) + " " + _vm._s(caipan.num) + "\n                    ")])], 1)
  }), 0), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "教练员",
      "placeholder": "请选择教练员"
    },
    on: {
      "click": function($event) {
        _vm.showJiaolianPicker = true
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.jiaolian.length > 0),
      expression: "formData.jiaolian.length>0"
    }],
    staticClass: "memberResultWrap"
  }, _vm._l((_vm.formData.jiaolian), function(jiaolian, index) {
    return _c('div', {
      staticClass: "memberLi"
    }, [_vm._v("\n                    教练员" + _vm._s(index + 1) + "\n                    "), _c('van-tag', {
      key: index,
      attrs: {
        "round": "",
        "color": "#fff",
        "text-color": "#666",
        "size": "large",
        "closeable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.jiaolian.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(jiaolian.name) + " " + _vm._s(jiaolian.num) + "\n                    ")])], 1)
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("下一步")])], 1)], 1), _vm._v(" "), _c('CaipanPicker', {
    attrs: {
      "show": _vm.showCaipanPicker,
      "limit": 1,
      "defaultValue": _vm.formData.caipan
    },
    on: {
      "onChange": _vm.onCaipanChange,
      "onClose": function($event) {
        _vm.showCaipanPicker = false
      },
      "onConfirm": _vm.onCaipanConfirm
    }
  }), _vm._v(" "), _c('JiaolianPicker', {
    attrs: {
      "show": _vm.showJiaolianPicker,
      "limit": 5,
      "defaultValue": _vm.formData.jiaolian
    },
    on: {
      "onChange": _vm.onJiaolianChange,
      "onClose": function($event) {
        _vm.showJiaolianPicker = false
      },
      "onConfirm": _vm.onJiaolianConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-645654aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiApplyFormStep1.vue
// module id = 2447
// module chunks = 0